export default "__VITE_ASSET__27ad0968__"